import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=04253126&scoped=true"
import script from "./ImageEditor.vue?vue&type=script&lang=js"
export * from "./ImageEditor.vue?vue&type=script&lang=js"
import style0 from "./ImageEditor.vue?vue&type=style&index=0&id=04253126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04253126",
  null
  
)

export default component.exports